import { TextVariant } from './types';

export const HEADER_CONSTANTS: Record<string, TextVariant> = {
  satelliteTitle: { common: '새틀라이트' },
  mainEventTitle: { common: '오프라인 이벤트' },
  satelliteDate1: {
    common: <>3월 16일(월) ~ 3월 27일(금)</>,
  },
  satelliteTime1: { common: '매일 오후 10시' },
  satelliteDate2: {
    common: <>3월 28일(토) ~ 4월 2일(목)</>,
  },
  satelliteTime2: { common: '매일 오후 8시, 10시' },
  satelliteApp: {
    common: '피망 쇼다운 홀덤\n 게임 앱 진행',
    mobile: '피망 쇼다운 홀덤 앱 진행',
  },
  mainEventDay: {
    common: <>DAY1 4월 5일(일)</>,
    pc: (
      <>
        DAY1
        <br /> <span>4월 5일(일)</span>
      </>
    ),
  },
  mainEventVenue: { common: '뉴스톤' },
  mainEventDetail: {
    common: (
      <>
        NLH Main Event Day 1,
        <br /> (SHOWDOWN HOLDEM
        <br /> Online Qualifiers){' '}
      </>
    ),
    pc: (
      <>
        NLH Main Event Day 1,
        <br /> (SHOWDOWN HOLDEM
        <br /> Online Qualifiers){' '}
      </>
    ),
  },
};
